import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from 'ng2-file-upload';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ngfModule } from 'angular-file';

import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { DocumentRoutingModule } from './document-routing.module';
import { LoadingSpinnerComponent } from '../../core/loading-spinner/loading-spinner.component';
import {CoreModule} from '../../core/core.module';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    DocumentRoutingModule,
    FileUploadModule,
    DropdownModule,
    FormsModule,
    StepsModule,
    NgbModule,
    ngfModule,
    CoreModule,
    TranslateModule
  ],
  declarations: [
    DocumentUploadComponent
  ]
})
export class DocumentModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document.module.ts